import React from 'react';
import InputMask from 'react-input-mask';
import { FormControl, TextField } from '@material-ui/core';

import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import isLabelFitToInput from 'app/shared/helpers/isLabelFitToInput';
import { useIbanControl } from 'app/shared/hooks/controls/useIbanControl';
import { IbanControlProps } from './IbanControl.interfaces';

export default function IbanControl(props: IbanControlProps) {
  const { meta, label, input, helperText, width } = props;

  const {
    error,
    focused,
    isValueCheckVisible,
    localValue,
    mask,
    maskChar,
    handleBlur,
    handleChange,
    onFocus,
  } = useIbanControl(props);

  return (
    <>
      <ControlContainer
        inputId={input.name}
        helperText={helperText}
        meta={meta}
        focused={focused}
        label={!isLabelFitToInput(label, width) ? label : ''}
        width={width || 'xs'}
      >
        <FormControl fullWidth>
          <InputMask
            mask={mask}
            maskChar={maskChar}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={onFocus}
          >
            {() => (
              <TextField
                id={input.name}
                InputProps={{
                  startAdornment: isValueCheckVisible && <DoneAdornment />,
                }}
                name={input.name}
                label={isLabelFitToInput(label, width) ? label : ''}
                error={error}
                variant={'outlined'}
                margin={'dense'}
                type="text"
              />
            )}
          </InputMask>
        </FormControl>
      </ControlContainer>
    </>
  );
}
